import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import { useSessionVisitBaseline } from './useSessionVisitBaseline';

export function useAssetsVisitBaseline({
  targetId,
  targetType,
}: {
  targetId: string | null;
  targetType: TargetTypeType;
}): Date | null {
  return useSessionVisitBaseline({ kind: 'assets', targetId, targetType })
    .baselineAt;
}
